import Image from 'next/image';
import { useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { ImageWithPlaceholder } from '~/utils/image-plaiceholder';
import cn from 'classnames';

type GalleryImageProps = {
   image: ImageWithPlaceholder;
   priorty?: boolean;
   mobile?: boolean;
};
export const GalleryImage = ({ image, priorty, mobile }: GalleryImageProps) => {
   const fallback_image = '/images/not_found.svg';
   return (
      <div className={cn('relative w-full h-full overflow-hidden', !mobile && 'rounded-lg')}>
         {image?.css ? (
            <div
               style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  transform: 'scale(1.5)',
                  filter: 'blur(40px)',
                  ...image.css,
               }}
            />
         ) : null}
         <Image
            layout="fill"
            src={image?.img?.src || fallback_image}
            className="object-cover"
            priority={priorty}
            quality={85}
         />
      </div>
   );
};
export const GalleryVideo = ({ src, mobile }: { src: string; mobile?: boolean }) => {
   const [playing, setPlay] = useState(false);
   const ref = useRef<HTMLVideoElement>(null);

   const togglePlay = () => setPlay(true);

   useEffect(() => {
      const elm = ref.current;
      if (elm) {
         if (playing) elm.play();
         else elm.pause();
      }
   }, [playing]);

   return (
      <div className="relative h-full">
         <video
            ref={ref}
            className={cn('object-cover w-full', mobile ? 'h-full' : 'h-[276px] rounded')}
            src={src}
            controls={playing}
            onPause={() => setPlay(false)}
         />
         {!playing && (
            <button
               onClick={togglePlay}
               className="absolute inset-0 z-10 flex items-center justify-center">
               <div className="flex items-center justify-center w-10 h-10 bg-white rounded-full focus:outline-none">
                  <img alt="" src="/icons/experiences/play_arrow.svg" width="27px" height="18px" />
               </div>
            </button>
         )}
      </div>
   );
};
